/**
 * Vorkommen eines Zeitraums, live aus der Datenbank.
 *
 * `useLiveQuery` horcht auf die Tabelle: jede Schreiboperation - auch aus einem
 * anderen Tab - loest ein Neurendern aus. Die Expansion selbst ist reine
 * Rechenarbeit und laeuft bei jeder Aenderung neu; bei der Groessenordnung
 * eines persoenlichen Kalenders ist das deutlich unter einer Millisekunde.
 */
import { useLiveQuery } from 'dexie-react-hooks';
import { useMemo } from 'react';

import { getOccurrences } from '@/db/repositories/events';
import { useAreaFilter } from '@/store/areaFilter';
import type { CalendarOccurrence } from '@/domain/types';
import type { Range } from '@/lib/recurrence/expand';

export function useOccurrences(range: Range): CalendarOccurrence[] {
  const { activeAreaIds } = useAreaFilter();

  const all = useLiveQuery(
    () => getOccurrences(range),
    [range.from, range.to],
    [] as CalendarOccurrence[],
  );

  return useMemo(() => {
    if (activeAreaIds.length === 0) return all;
    return all.filter((o) => o.areaId != null && activeAreaIds.includes(o.areaId));
  }, [all, activeAreaIds]);
}
